export default "__VITE_ASSET__rQywQMxi0Kin8YoQmFMnXQ__"